import {ACTION_TYPES} from "../../../core/consts";

import {FetchHandler} from "../../../infrastructure/handlers/fetch-handler";
import {NewsDomainService} from "../../../domain/news/services/news.domain-service";
import {BaseApiRequestParams} from "../../../infrastructure/models/params/base-api-request-params";
import {NewsRequestParams} from "../../../domain/news/models/news.request-params";
import {NewsDataSource} from "../../../domain/news/models/news-data-source";
import {UserSelectionsManager} from "../../../core/managers/user-selections.manager";
import {NEWS} from "../news-widget.consts";
import {NewsWidgetItemViewModel} from "../models/news-widget.item.view-model";
import {debounce} from "../../../infrastructure/debounce/debounce";

export class NewsWidgetFetchHandler extends FetchHandler {
  static injectables = [NewsDomainService, UserSelectionsManager];

  constructor(service: NewsDomainService, userSelectionsManager: UserSelectionsManager) {
    super(service);

    this.userSelectionsManager = userSelectionsManager;
  }

  async onLoaded() {
    super.onLoaded();

    if (this.controller.state.props.shouldUseSelections) {
      this.debouncedAction = debounce(() => this.action(), 1000);
      this.userSelectionsManager.registerToActions("NewsWidgetFetchHandler", () => this.debouncedAction());
    }


    this.action();
    this.sendDisplayEvent();
  }

  get requestParams(): BaseApiRequestParams {
    const sportsIds = this.controller.state.props.sportTypeIds;
    const countriesIds = this.controller.state.props.countriesIds;
    const competitionsIds = this.controller.state.props.competitionsIds;
    const competitorsIds = this.controller.state.props.competitorsIds;
    const athletesIds = this.controller.state.props.athletesIds;
    const gamesIds = this.controller.state.props.gamesIds;
    const userCompetitionIds = this.controller.state.props.shouldUseSelections ? this.userSelectionsManager.competitionsIds : null;
    const userCompetitorsIds = this.controller.state.props.shouldUseSelections ? this.userSelectionsManager.competitorsIds : null;
    const isPreview = this.controller.state.props.isPreview;

    const requestParams: NewsRequestParams = new NewsRequestParams(sportsIds, countriesIds, competitionsIds, competitorsIds, gamesIds, athletesIds, userCompetitionIds, userCompetitorsIds, isPreview);

    return requestParams;
  }

  async action(params) {
    const dataSource: NewsDataSource = await this.fetch();

    await this.controller.action(ACTION_TYPES.populateData, {dataSource});
    this.controller.props.onWidgetVisible?.(this.state.isPopulated);
    this.sendDisplayArticlesEvent();
    return dataSource;
  }

  onDidUpdate(prevProps, nextProps) {
    super.onDidUpdate(prevProps, nextProps);
    const isSportChanged: Boolean = prevProps.sportTypeIds?.first() !== nextProps.sportTypeIds?.first()
    const isCompetitorChanged: Boolean = prevProps.competitorsIds?.first() !== nextProps.competitorsIds?.first()
    const isCompetitionChanged: Boolean = prevProps.competitionsIds?.first() !== nextProps.competitionsIds?.first()
    const isAthleteChanged: Boolean = prevProps.athletesIds?.first() !== nextProps.athletesIds?.first()
    const isGameChanged: Boolean = prevProps.gamesIds?.first() !== nextProps.gamesIds?.first()
    const isPreviewChanged: Boolean = prevProps.isPreview !== nextProps.isPreview;

    if (isSportChanged || isCompetitorChanged || isCompetitionChanged || isAthleteChanged || isGameChanged || isPreviewChanged) {
      this.action();
    }
  }

  onUnloaded() {
    super.onUnloaded();

    this.userSelectionsManager.unregisterToActions("NewsWidgetFetchHandler");
  }

  sendDisplayEvent() {
    this.controller.action(NEWS.ACTION_TYPES.displayHandler, {
      countryId: this.state.appState.locale.userCountryId,
      langId: this.state.appState.locale.language.id,
      sportTypeId: this.state.appState.context.sportType?.id
    });
  }

  sendDisplayArticlesEvent() {
    this.state?.news?.forEach((article: NewsWidgetItemViewModel) => this.controller.action(NEWS.ACTION_TYPES.onArticleDisplay, {
      countryId: this.state.appState.locale.userCountryId,
      langId: this.state.appState.locale.language.id,
      sportTypeId: this.state.appState.context.sportType?.id,
      sourceId: article.source.id,
      articleId: article.id
    }))
    ;
  }
}
